<ham-modal
    [title]="
        view === 'confirm_revoke'
            ? ('aumico_outbound_api_revoke_confirm_title' | i18next)
            : view === 'secret'
            ? ('aumico_outbound_api_secret_modal_title' | i18next)
            : client.displayName
    "
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onClose()"
>
    <div class="info-modal-body">
        <!-- ─────────── Detail ─────────── -->
        <ng-container *ngIf="view === 'detail'">
            <div class="detail-row">
                <span class="detail-row__label">{{ 'aumico_outbound_api_client_id_label' | i18next }}</span>
                <code class="detail-row__value" data-testid="outbound-info-client-id">{{ client.clientId }}</code>
            </div>
            <div class="detail-row">
                <span class="detail-row__label">{{ 'aumico_outbound_api_scopes_label_long' | i18next }}</span>
                <span class="detail-row__value">
                    <code *ngFor="let scope of client.scopes" class="scope-chip">{{ scope }}</code>
                </span>
            </div>
            <div class="detail-row">
                <span class="detail-row__label">{{ 'aumico_outbound_api_created_label' | i18next }}</span>
                <span class="detail-row__value">{{ client.createdAt | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="detail-row" *ngIf="client.secretRotatedAt != null">
                <span class="detail-row__label">{{ 'aumico_outbound_api_rotated_label' | i18next }}</span>
                <span class="detail-row__value">{{ client.secretRotatedAt | date: 'dd.MM.yyyy HH:mm' }}</span>
            </div>

            <div class="footer" *ngIf="client.status === 'active'">
                <ham-button
                    variant="gray"
                    data-testid="outbound-info-rotate"
                    [disabled]="(mutating$ | async) === true"
                    (buttonClick)="onRotate()"
                    >{{ 'aumico_outbound_api_rotate_button' | i18next }}</ham-button
                >
                <ham-button variant="red" data-testid="outbound-info-revoke" (buttonClick)="onRevokeRequested()">
                    {{ 'aumico_outbound_api_revoke_button' | i18next }}
                </ham-button>
            </div>
        </ng-container>

        <!-- ─────────── Rotated secret (one-time reveal) ─────────── -->
        <ng-container *ngIf="view === 'secret' && rotated != null">
            <div class="secret-warning">{{ 'aumico_outbound_api_secret_warning' | i18next }}</div>
            <div class="detail-row">
                <span class="detail-row__label">{{ 'aumico_outbound_api_client_secret_label' | i18next }}</span>
            </div>
            <div class="secret-row">
                <code class="secret-row__value" data-testid="outbound-rotated-secret">{{ rotated.clientSecret }}</code>
                <ham-button variant="gray" size="xs" (buttonClick)="onCopySecret()">
                    {{ (copied ? 'aumico_outbound_api_copied' : 'aumico_outbound_api_copy') | i18next }}
                </ham-button>
            </div>
            <div class="footer">
                <ham-button variant="primary" (buttonClick)="onClose()">{{ 'aumico_outbound_api_done' | i18next }}</ham-button>
            </div>
        </ng-container>

        <!-- ─────────── Revoke confirmation ─────────── -->
        <ng-container *ngIf="view === 'confirm_revoke'">
            <div class="revoke-warning" data-testid="outbound-revoke-warning">
                {{ 'aumico_outbound_api_revoke_confirm_text' | i18next }}
            </div>
            <div class="footer">
                <ham-button variant="gray" (buttonClick)="onBackToDetail()">{{ 'aumico_button_cancel' | i18next }}</ham-button>
                <ham-button
                    variant="red"
                    data-testid="outbound-revoke-confirm"
                    [disabled]="(mutating$ | async) === true"
                    (buttonClick)="onRevokeConfirmed()"
                    >{{ 'aumico_outbound_api_revoke_confirm_button' | i18next }}</ham-button
                >
            </div>
        </ng-container>
    </div>
</ham-modal>
